/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_WhatsappInputs */

const cs_enum_whatsapp = /** @type {(inputs: Enum_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

const en_enum_whatsapp = /** @type {(inputs: Enum_WhatsappInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WhatsApp`)
};

/**
* | output |
* | --- |
* | "WhatsApp" |
*
* @param {Enum_WhatsappInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_whatsapp = /** @type {((inputs?: Enum_WhatsappInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_WhatsappInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_whatsapp(inputs)
	return cs_enum_whatsapp(inputs)
});